<script setup>
import { Head } from '@inertiajs/vue3';
import FrontLayout from '@/Layouts/FrontLayout.vue';
import PageHero from '@/Components/Front/PageHero.vue';

const props = defineProps({
    setting: Object,
    syaratKetentuan: Object,
    title: String,
    meta_description: String,
    meta_keywords: String,
    og_title: String,
    og_description: String,
    og_image: String,
    og_url: String,
    twitter_title: String,
    twitter_description: String,
    twitter_image: String,
});
</script>

<template>
    <FrontLayout 
        :setting="setting"
        :title="title"
        :metaDescription="meta_description"
        :metaKeywords="meta_keywords"
        :ogTitle="og_title"
        :ogDescription="og_description"
        :ogImage="og_image"
        :ogUrl="og_url"
        :twitterTitle="twitter_title"
        :twitterDescription="twitter_description"
        :twitterImage="twitter_image"
    >
        <Head>

            <meta name="description" :content="meta_description">
            <meta name="keywords" :content="meta_keywords">
            <!-- Canonical handled by layout or Inertia if needed -->
        </Head>

        <PageHero 
            :title="syaratKetentuan?.hero_title || 'Syarat & Ketentuan'"
            :subtitle="syaratKetentuan?.hero_subtitle"
            :breadcrumbs="[
                { label: 'Beranda', url: '/' },
                { label: syaratKetentuan?.title || 'Syarat & Ketentuan' }
            ]"
        />

        <section class="py-12 md:py-16 bg-white dark:bg-gray-900 min-h-[500px]">
            <div class="container mx-auto px-4 lg:px-6 xl:px-8 max-w-4xl">
                <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
                    <div class="p-4">
                        <!-- Intro Text -->
                        <div v-if="syaratKetentuan?.intro_text" class="mb-10 text-center">
                            <h2 class="text-xl md:text-2xl font-bold text-gray-800 dark:text-white leading-relaxed">{{ syaratKetentuan.intro_text }}</h2>
                        </div>

                        <!-- Main Content -->
                        <div class="prose prose-lg max-w-none prose-headings:text-gray-900 dark:prose-headings:text-white prose-p:text-gray-600 dark:prose-p:text-gray-300 prose-li:text-gray-600 dark:prose-li:text-gray-300 prose-a:text-blue-600 hover:prose-a:text-blue-700 dark:prose-invert">
                            <div v-html="syaratKetentuan?.content"></div>
                        </div>

                        <!-- Info Box -->
                        <div class="mt-12 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-xl p-4 flex items-start gap-4">
                            <div class="bg-blue-100 dark:bg-blue-800 p-2 rounded-full text-blue-600 dark:text-blue-300 mt-1 flex-shrink-0">
                                <i class="fa fa-info-circle text-xl"></i>
                            </div>
                            <div>
                                <h4 class="text-lg font-bold text-gray-900 dark:text-white mb-2">Informasi Penting</h4>
                                <p class="text-gray-600 dark:text-gray-300 leading-relaxed">
                                    Syarat dan ketentuan ini dapat berubah sewaktu-waktu tanpa pemberitahuan sebelumnya. 
                                    Pelanggan disarankan untuk selalu memeriksa halaman ini secara berkala.
                                </p>
                            </div>
                        </div>

                        <!-- Last Updated -->
                        <div class="mt-8 pt-8 border-t border-gray-100 dark:border-gray-700 text-center">
                             <p class="text-gray-500 dark:text-gray-400 text-sm flex items-center justify-center gap-2">
                                <i class="fa fa-clock-o"></i>
                                Terakhir diperbarui: {{ new Date().toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }) }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </FrontLayout>
</template>
